import axios from 'axios';

const Constants = {
  API_BASE_URL: 'https://klmsdata.kaist.ac.kr'
  // API_BASE_URL: 'http://localhost:5000'
}

const UT = {
  // object 여부
  isObject(v) {
    return v !== null && typeof v === 'object';
  },
  // function 여부
  isFunction(v) {
    return typeof v === 'function';
  },
  // Date 여부
  isDate(v) {
    return this.isObject(v) && typeof v.getTime === 'function';
  },
  // array 여부
  isArray(v) {
    return Array.isArray(v);
  },
  // string 여부
  isString(v) {
    return typeof v === 'string';
  },
  // boolean 여부
  isBoolean(v) {
    return typeof v === 'boolean';
  },
  // 숫자 여부
  isNumber(v) {
    return typeof v === 'number';
  },
  // 숫자 여부
  isUndefined(v) {
    return typeof v === 'undefined';
  },
  // 데이터의 empty 여부
  isEmpty(v) {
    return (v === null)
      || (typeof v === 'undefined')
      || (this.isObject(v) && !Object.keys(v).length && !this.isDate(v))
      || (this.isString(v) && v.trim() === '')
      || (this.isArray(v) && v.length === 0);
  },
  async api(options) {
    if (UT.isEmpty(options.method)) {
      options.method = "post";
    }
    axios.defaults.baseURL = Constants.API_BASE_URL; // 'http://211.56.5.90';
    return axios(options);
  },
  async request(options, callback) {
    try {
      if (UT.isEmpty(options.method)) {
        options.method = "post";
      }
      const response = await axios(options);
      if (UT.isFunction(callback)) {
        callback.call(this, {
          data: response.data,
          status: response.status,
          statusText: response.statusText,
          headers: response.headers,
        });
      }
    } catch (error) {
      console.log(error);
    }
  },
  alert(me, message, args, callback) {
    const props = {
      title: '알림',
      buttonTrueText: '확인',
      message: message
    };
    const alert = me.$dialog.open(props);
    alert.$on('closed', (type) => {
      if (UT.isFunction(callback)) {
        callback.call(this, type);
      }
    });
  },
  toFixed(num, digits) {
    num = parseFloat(num);
    let str = num.toFixed(digits).toString();
    str = str.replace('.' + ('0'.repeat(digits)),'');
    return parseFloat(str);

  },
  formatString(string, ...values) {
    // eslint-disable-next-line prefer-rest-params
    values = this.isObject(values) ? values : Array.prototype.slice.call(arguments, 1);
    if (UT.isEmpty(string)) {
      return '';
    }
    return string.replace(/\{([^{}]+)\}/gm,
      (matched, key) => (typeof values[key] === 'undefined' ? matched : values[key]));
  },
  formatCurrency(num, digits) {
    num = parseFloat(num);
    return num.toFixed(digits).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
  }
}

export default UT;
